import { Dialog, Stack, Text, Portal } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { initialProjectState, setProjectState } from '../../lib/state/slices/ProjectStateSlice';
import StyledButton from '../ui/styledButton';
import { useSaveProjectStateMutation } from '@/lib/api/GraphAPI';
import { useAppSelector } from '@/lib/hooks';
import { cloneDeep } from 'lodash';


export default function DeleteStateDialog(props: {
  isOpen: boolean;
  onClose: () => void;
  stateId: string;
}) {
  
  const state = useAppSelector((state) => state.viewReducer); 
  
  const [saveView] = useSaveProjectStateMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  return (
    <Dialog.Root open={props.isOpen} onOpenChange={props.onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content backgroundColor="midCardBG">
            <Dialog.Header>
              <Dialog.Title color="primaryText">Delete Data</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Stack gap={4}>
                <Text color="secondaryText">
                  Are you sure you want to delete the data of this project?
                </Text>
                <Text color="secondaryText">This cannot be undone.</Text>
              </Stack>
            </Dialog.Body>
            <Dialog.Footer>
              <StyledButton variant="outline" text="Cancel" onClick={props.onClose} />
              <StyledButton
                variant="danger"
                text="Delete"
                onClick={() => {
                  
                  if (state.id !== props.stateId) {
                    console.error("Something went wrong.")
                    return;
                  }
                  
                  const freshProjectState = cloneDeep(initialProjectState);
                  
                  freshProjectState.id = state.id;
                  freshProjectState.name = state.name;
                  freshProjectState.isAutosaveActive = true;
                  
                  dispatch(setProjectState(freshProjectState));
                  saveView(freshProjectState);
                  
                  navigate("/research")
                  window.location.reload();
                  
                  props.onClose();
                }}
              />
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
